module.exports = __webpack_public_path__ + "static/SP-panel-bridge-controller-spec-sheet-70a4a4c8c2cbc11db36eefa54ccc3e8e.pdf";